import React from "react";
import { CreateContainer } from "./ContainerCreate";
import { getSleeves } from "../../api/getSleeves";
import Skeleton from "react-loading-skeleton";

class SleevesContainer extends React.Component {
  componentDidMount() {
    const page = this.props.page || 1;
    this.props.request(page);
  }
  componentWillReceiveProps(nextProps) {
    const { page: nextPage } = nextProps;
    const { page } = this.props;
    if (nextPage !== page) {
      this.props.request(nextPage);
    }
  }
  render = () => {
    const { data, loading, failure, render } = this.props;
    const result = (data && data.data) || [];
    if (loading) {
      return <Skeleton count={3} />;
    }
    // if (!loading && sleeves.length === 0) {
    //   return null;
    // }
    return render({ result, loading, failure });
  };
}

export default CreateContainer(getSleeves, SleevesContainer);
